import { useTranslation } from 'react-i18next'

const ComputerScreen = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="computerscreen-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="computerscreen-title">{t('antagonists:troll:components:background')}</title>
      <defs>
        <clipPath id="computer-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="computer-c">
          <path
            d="m1401.83 426.77-4.91 17.39-13.6 19.94.16 212.31 6.42 16.78s19.62 9.91 62.61 10.36c50.81.54 67.61-9.72 67.61-9.72l8.69-15.48 5.89-209.72-11.79-26.29.83-12.69-121.91-2.88Z"
            style={{
              fill: '#ffd500',
            }}
          />
        </clipPath>
        <clipPath id="computer-d">
          <path
            style={{
              fill: '#00756b',
            }}
            d="M-109.34-219.69H396v642.88h-505.34z"
          />
        </clipPath>
        <clipPath id="computer-e">
          <path
            style={{
              fill: '#4e6c78',
            }}
            d="M540.96 718.99 367.31 910.92l15.81 44.51 1171.64-9.17 13.19-40.59-172.02-189.01-854.97 2.33z"
          />
        </clipPath>
        <clipPath id="computer-f">
          <path
            style={{
              fill: '#f3e5cc',
            }}
            d="m1412.2 1009.64 51.72 6.11 380.44-90.53 3.11-10.37-5.15-14.18-9.63-7.65-380.5 85.34-40.07 30.28.08 1z"
          />
        </clipPath>
        <style>
          {
            '.h,.i{fill:none}.j{fill:#f3e5cc}.k{fill:#00756b}.l{fill:#0081c2}.m{fill:#ebeee3}.n{fill:#ed7a30}.o{fill:#f0e0c1}.p{fill:#fdd900}.q{fill:#e95e27}.r{fill:#e63e27}.s{fill:#ea6527}.t{fill:#ffd500}.u{fill:#ee7f00}.v{fill:#eee2dd}.w{fill:#fcf8f1}.x{fill:#72929d}.y{fill:#00a183}.aa{fill:#8db2bf}.ab{fill:#d02b86}.ac{fill:#d94288}.ad{fill:#d7be7e}.ae{fill:#d29dc3}.af{fill:#d55596}.ag{fill:#171f41}.ah{fill:#234335}.ai{fill:#428a3d}.aj{fill:#a2bec9}.ak{fill:#55ac42}.al{fill:#3b9bd2}.am{fill:#3aaba8}.an{fill:#469857}.ao{fill:#4e6c78}.ap{fill:#4d8d97}.i{stroke:#425d68;stroke-miterlimit:10;stroke-width:5.47px}.aq{clip-path:url(#computer-c)}.ar{clip-path:url(#computer-b)}.as{clip-path:url(#computer-f)}.at{clip-path:url(#computer-e)}.au{clip-path:url(#computer-d)}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#computer-b)',
        }}
        id="computer-a"
      >
        <path
          style={{
            fill: '#ebeee3',
          }}
          d="M-154.61-434.66h2543.99v1787.37H-154.61z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#a2bec9',
          }}
          d="m-254.05 645.05 2722.7-10.79 87.18 997.93-2985.75 23.07 175.87-1010.21z"
        />
        <path
          d="M530.84 810.03s-63.46-21.15-134.84 5.29c-49.9 18.48-81.96 55.52-148.06 68.74-101.21 20.24-137.79-57.6-249.72-55.27-129.97 2.71-349.81 37.46-458 145.42"
          style={{
            fill: 'none',
            stroke: '#425d68',
            strokeMiterlimit: 10,
            strokeWidth: '5.47px',
          }}
        />
        <path
          d="M514.98 794.17s-48.02-34.61-164.62-9.68c-137.99 29.5-212.95-36.85-345.14-20.99-203.1 24.37-118.01 168.2-249.05 136.43-131.04-31.77-297.6-282.24-362.9-211.78"
          style={{
            fill: 'none',
            stroke: '#425d68',
            strokeMiterlimit: 10,
            strokeWidth: '5.47px',
          }}
        />
        <path
          d="m1401.83 426.77-4.91 17.39-13.6 19.94.16 212.31 6.42 16.78s19.62 9.91 62.61 10.36c50.81.54 67.61-9.72 67.61-9.72l8.69-15.48 5.89-209.72-11.79-26.29.83-12.69-121.91-2.88Z"
          style={{
            fill: '#ffd500',
          }}
        />
        <g
          style={{
            clipPath: 'url(#computer-c)',
          }}
        >
          <path
            style={{
              fill: '#d94288',
            }}
            d="m1523.84 772.6-110.79-223.77 124.63-106.92 184.29 132.75-27.32 208.92-170.81-10.98z"
          />
          <path
            style={{
              fill: '#ed7a30',
            }}
            d="m1564.36 774.92-107.87-216.97 96.07-85.36 199.4 85.18-27.32 208.92-160.28 8.23z"
          />
          <path
            style={{
              fill: '#e63e27',
            }}
            d="m1603.62 785.4-107.79-217.2 64.72-63.83L1797 568.3l-27.32 208.92-166.06 8.18z"
          />
          <path
            style={{
              fill: '#e95e27',
            }}
            d="m1582.49 803.23-39.64-241.91 64.33-38.49 204.42 134.92-91.52 189.79-137.59-44.31z"
          />
          <path
            style={{
              fill: '#55ac42',
            }}
            d="m1576.39 791.51-39.64-241.92 81.49-40.29 204.42 134.92-91.51 189.79-154.76-42.5z"
          />
          <path
            style={{
              fill: '#e95e27',
            }}
            d="m1592.29 785.2-39.65-241.92 81.49-40.29 204.43 134.91-91.52 189.8-154.75-42.5z"
          />
          <path
            style={{
              fill: '#55ac42',
            }}
            d="m1602.74 771.72-39.64-241.91 81.48-40.3 204.43 134.92-91.51 189.79-154.76-42.5z"
          />
          <path
            d="M1379.22 667.06s22.65 15.12 70.89 15.58c54.2.51 100.62-15.73 100.62-15.73l.64 44.81-169.48-2.28s-4.19-43.9-2.67-42.39Z"
            style={{
              fill: '#f0e0c1',
            }}
          />
          <path
            d="M1458.61 458.42c-78.66 2.58-76.49-31.95-76.49-31.95l-4.72-49.54 152.78-5.35 8.19 60.49s-31.03 24.76-79.76 26.35Z"
            style={{
              fill: '#9ebcc7',
            }}
          />
        </g>
        <path
          d="M1524.05 426.2c2.28 10.67-9.39 19.28-53.81 22.9-44.41 3.62-74.33-7.25-72.51-19.04 1.97-12.83 29.91-20.85 58.92-20.85 29 0 64.68 4.29 67.4 16.98Z"
          style={{
            fill: '#9ebcc7',
          }}
        />
        <path
          d="M1468.04 435.55s-6.5 10.31-30.8 10.17c-15.73-.09-21.17-13.62-9.45-17.15 10.75-3.24 31.2-3.01 31.2-3.01l9.04 9.99Z"
          style={{
            fill: '#234335',
          }}
        />
        <path
          d="M1512.97 408.54c-15.16 14.69-35.46 32.18-48.68 24.91-13.22-7.27 2.7-25.63 15.26-35.76 12.56-10.14 15.24-17.47 29.56-12.4 14.32 5.07 10.91 16.42 3.85 23.26Zm-19.07-14.55c-4.82 3.48-6.5 10.99-2.13 13.45s10.38 1.4 14.64-1.96 6.92-8.49 2.57-11.66c-5.38-3.92-10.26-3.31-15.08.17Zm-27.8 26.23c-1.23 4.04 7.33 10.62 10.47 9.05 3.14-1.57 15.33-12.1 10.49-15.86-6.05-4.71-19.73 2.78-20.96 6.81Z"
          style={{
            fill: '#72929d',
          }}
        />
        <path
          style={{
            fill: '#fcf8f1',
          }}
          d="m1627.42 725.24 148.32 145.36 335.55-52.44-153.37-165.47-330.5 72.55z"
        />
        <path
          style={{
            fill: '#469857',
          }}
          d="m1585.1 824.96 353.97-94.94 171.46 184.43-345.22 116.56-180.21-206.05z"
        />
        <path
          style={{
            fill: '#ffd500',
          }}
          d="m1792.08 719.27-110.7 194.67 364.57 129 65.57-216.65-319.44-107.02z"
        />
        <path
          style={{
            fill: '#d7be7e',
          }}
          d="m420.18 450.08-547.63-1.75v-696.45l547.63 1.75v696.45z"
        />
        <path
          style={{
            fill: '#00756b',
          }}
          d="M-109.34-219.69H396v642.88h-505.34z"
        />
        <g
          style={{
            clipPath: 'url(#computer-d)',
          }}
        >
          <path
            style={{
              fill: 'none',
            }}
            d="M-306.66-142.06 92.95 635.23l502.56-759.38-902.17-17.91z"
          />
          <path
            style={{
              fill: '#3b9bd2',
            }}
            d="M-430.36-114.22-54 473.68l398.09-648.29-774.45 60.39z"
          />
          <path
            style={{
              fill: '#00a183',
            }}
            d="m-30.71-286.86 357.88 929.49 529.53-863.7-887.41-65.79z"
          />
          <path
            style={{
              fill: '#171f41',
            }}
            d="m-146.3-590.37 285.97 751.51 336.97-734.89-622.94-16.62z"
          />
        </g>
        <path
          d="M570.3 78.24c-24.87 0-35 5.96-35.75 30.53-.97 31.93.22 552.71.22 570.43s9 31.6 31.23 32.16c22.22.56 780.01-.17 802.63-1 28.03-1.03 37.86-8.98 39.2-32.9 1.33-23.92 1.65-550.09 1-568.68-.79-23.03-3.05-30.69-28.3-32.02-25.25-1.33-788.9 1.49-810.23 1.49ZM540.96 718.99 367.31 910.92l15.81 44.51 1171.64-9.17 13.19-40.59-172.02-189.01-854.97 2.33z"
          style={{
            fill: '#4e6c78',
          }}
        />
        <g
          style={{
            clipPath: 'url(#computer-e)',
          }}
        >
          <path
            style={{
              fill: '#4d8d97',
            }}
            d="m326.65 926.29 1254-9.1.84 113.71-1195.31-15.36-59.53-89.25z"
          />
        </g>
        <path
          style={{
            fill: '#fcf8f1',
          }}
          d="M565.49 110.44h812.41v556.57H565.49z"
        />
        <path
          d="M856.54 840.62 840 870.67c-2.79 5.07.88 11.28 6.67 11.27l290.53-.29c5.63 0 9.3-5.91 6.81-10.96l-15.58-31.65a19.162 19.162 0 0 0-17.39-10.69l-238.1 2.47a18.93 18.93 0 0 0-16.4 9.81Z"
          style={{
            fill: '#d55596',
          }}
        />
        <path
          style={{
            fill: '#234335',
          }}
          d="m582.87 730.95-51.39 85.13 867.54-6.16-51.17-82.99-764.98 4.02z"
        />
        <path
          d="m590.99 740.83-7.65 9.81c-1.98 2.54.37 5.79 4.19 5.79h18.91c2.16 0 4.07-1.1 4.69-2.71l3.82-9.81c.95-2.45-1.4-4.92-4.69-4.92h-15.09c-1.71 0-3.31.7-4.19 1.84Z"
          style={{
            fill: '#428a3d',
          }}
        />
        <path
          d="m625.32 741.55-3.58 10.03c-.9 2.51 1.55 4.99 4.9 4.97l17.23-.11c2.48-.02 4.58-1.43 4.95-3.34l1.91-9.92c.46-2.37-1.9-4.5-4.99-4.5h-15.57c-2.27 0-4.25 1.18-4.86 2.87Z"
          style={{
            fill: '#ee7f00',
          }}
        />
        <path
          d="m657.8 742.46-1.61 10.35c-.33 2.14 1.81 4.02 4.58 4.02H676c2.44 0 4.46-1.49 4.61-3.38l.81-10.67c.16-2.1-2.04-3.86-4.74-3.8l-14.42.33c-2.28.05-4.17 1.39-4.45 3.16Z"
          style={{
            fill: '#fdd900',
          }}
        />
        <path
          d="m578.43 762.95-8.69 11.15c-2.25 2.89.42 6.58 4.77 6.58h21.5c2.46 0 4.62-1.25 5.34-3.08l4.35-11.15c1.08-2.78-1.59-5.59-5.34-5.59H583.2c-1.95 0-3.76.79-4.77 2.09Z"
          style={{
            fill: '#3aaba8',
          }}
        />
        <path
          d="m616.6 763.49-4.06 11.4c-1.02 2.85 1.76 5.67 5.57 5.65l19.58-.12c2.82-.02 5.2-1.63 5.62-3.8l2.18-11.28c.52-2.7-2.16-5.12-5.67-5.12h-17.7c-2.58 0-4.84 1.34-5.52 3.27Z"
          style={{
            fill: '#d29dc3',
          }}
        />
        <path
          d="m565.77 787.31-9.94 12.75c-2.57 3.3.48 7.52 5.45 7.52h24.58c2.81 0 5.29-1.43 6.1-3.52l4.97-12.75c1.24-3.18-1.82-6.39-6.1-6.39h-19.61c-2.23 0-4.3.91-5.45 2.39Z"
          style={{
            fill: '#d02b86',
          }}
        />
        <path
          d="m1340.21 779.34 4.65 13.03c1.16 3.26-2.01 6.48-6.37 6.46l-22.39-.14c-3.22-.02-5.95-1.86-6.43-4.34l-2.49-12.89c-.59-3.08 2.47-5.85 6.48-5.85h20.23c2.95 0 5.53 1.53 6.32 3.73Z"
          style={{
            fill: '#8db2bf',
          }}
        />
        <path
          d="m1288.39 755.5 2.47 10.85c.53 2.33-1.56 4.43-4.47 4.44l-15.94.06c-2.55.01-4.66-1.62-4.82-3.69l-.83-11.19c-.16-2.12 2-3.88 4.67-3.84l14.27.23c2.27.04 4.24 1.36 4.64 3.14Z"
          style={{
            fill: '#eee2dd',
          }}
        />
        <path
          d="m1296.92 779.03 3.41 14.42c.74 3.13-1.78 5.94-5.4 5.93h-19.8c-3.17 0-5.81-2.2-6.03-4.98l-1.17-14.87c-.22-2.79 2.41-5.09 5.68-5.02l17.5.36c2.78.06 5.25 1.81 5.8 4.15Z"
          style={{
            fill: '#0081c2',
          }}
        />
        <path
          style={{
            fill: '#f3e5cc',
          }}
          d="m1412.2 1009.64 51.72 6.11 380.44-90.53 3.11-10.37-5.15-14.18-9.63-7.65-380.5 85.34-40.07 30.28.08 1z"
        />
        <g
          style={{
            clipPath: 'url(#computer-f)',
          }}
        >
          <path
            style={{
              fill: '#234335',
            }}
            d="m1444.08 1020.59-12.18-32.61-33.67 16.84 17.85 26.12 28-10.35z"
          />
          <path
            d="M1463.9 1026.14s12.64-7.35 9.81-17.87c-2.84-10.52-13.29-9.43-13.29-9.43l-.22-1.55s11.25-4.2 8.85-14.41c-2.03-8.62-16.33-12.95-16.33-12.95l405.09-95.04 5.21 76.61-399.12 74.64Z"
            style={{
              fill: '#ea6527',
            }}
          />
        </g>
      </g>
    </svg>
  )
}

export default ComputerScreen
